export default {
  loading: false,
  listLoading: false,
  records: [],
  total: 0,
  FilteredCount: 0,
  createLoading: false,
  unreadCount: 0,
  record: {}
}
